import type { CartItem, Contact, OtherRole } from "@/lib/domains";

export const OTHER_ROLES: OtherRole[] = ["admin", "tech", "billing"];

/** The roles at least one name in the cart has a contact for (a registry may have none besides the registrant). */
export function cartRoles(items: CartItem[]): OtherRole[] {
  return OTHER_ROLES.filter((r) => items.some((i) => (i.contact_roles ?? []).includes(r)));
}

/** The names whose registry has no contact for `role`: the registrant is used there. */
export function namesWithout(items: CartItem[], role: OtherRole): string[] {
  return items.filter((i) => !(i.contact_roles ?? []).includes(role)).map((i) => i.fqdn);
}

/** The chosen role contacts that still apply: a role in the cart, and a contact still saved (an archived one
 * drops back to the registrant). */
export function chosenRoles(
  items: CartItem[],
  chosen: Partial<Record<OtherRole, string>> | undefined,
  saved: Contact[],
): [OtherRole, Contact][] {
  return cartRoles(items).flatMap((role) => {
    const found = saved.find((c) => c.id === chosen?.[role]);
    return found ? [[role, found] as [OtherRole, Contact]] : [];
  });
}
